import { useAuthStore } from "~/stores/auth";
import { useConfigStore } from "~/stores/configStore";

/**
 * Pages that belong to someone who is not signed in: a lead public form at
 * /lead-public-form/{slug}, and the single form a customer completes from a
 * link they were sent.
 */
const PUBLIC_PATHS = ["/lead-public-form/", "/lead-form-submission"];

const isPublicPage = () =>
  PUBLIC_PATHS.some((path) => window.location.pathname.startsWith(path));

export default defineNuxtPlugin(async (nuxtApp) => {
  // A public page shows nothing that depends on the signed-in account, so an
  // admin opening one in their own browser should not drag the whole session
  // in behind it.
  if (isPublicPage()) return;

  const configStore = useConfigStore();
  const authStore = useAuthStore();
  if (authStore.token) {
    await authStore.getPermissions();
    await configStore.getConfig();
    await authStore.getActivatedFeatures();
    const activatedFeatures = authStore.features;
    // if (activatedFeatures.call_center) {
    //   await authStore.getAgentSettings();
    // }
  }
});
